import DashboardHeader from "@/components/DashboardHeader";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import EditCompany from "../company/components/EditCompany";
import EditBartender from "../company/components/EditBartender";
import { GET, POST } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import { API_ROUTES } from "@/services/environment";
import { Link, useSearchParams } from "react-router-dom";
import ToggleInput from "@/components/toggle/Toggle";
import { EditIcon } from "@/constants/utils/svgs";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { CompanyInterface } from "../company/interface";
import EditPackage from "../company/components/EditPackage";
import EditCocktail from "../company/components/EditCocktail";
import CreatePackage from "../company/components/CreatePackage";
import CreateCocktails from "../company/components/CreateCocktails";
import { formStateChange } from "@/redux/slices/formSlice";
import { useDispatch } from "react-redux";
import ChangesAlert from "@/components/alert/ChangesAlert";
import { IoMdArrowBack } from "react-icons/io";
import DiscountManager from "../DiscountManager";
import AddBTCBySuperAdmin from "./BTC/AddEditBTCBySuperAdmin";
import BartList from "./BTC/BartList";
import BTCTable from "./BTC/BTCTable";
import BartenderSchedulePage from "../Schedule/BartenderSchedulePage";
import { FiEdit2 } from "react-icons/fi";
import { Cocktail } from "../events/Interface";
import PriceCalculator from "@pages/company/PriceCalculation2/PriceCalculation"

const tabs = {
  Business: "business",
  Bartenders: "barts",
  Schedules: "schedules",
  Packages: "packages",
  PriceCalculator: "priceCalculator",
  Discount: "discounts",
  Cocktails: "cocktails",
} as const;

type TabType = (typeof tabs)[keyof typeof tabs];
interface TabState {
  state: "Add" | "Edit" | "Close";
  id: string;
  tab: TabType;
  name?: string;
}

const EditCompanyPage = () => {
  const params = useParams();
  const { getCompanyApi, allBartenders } = API_ROUTES;
  // == for unsaved changes ==
  const { isChanged } = useAppSelector((store) => store.form);
  const [modal, setModal] = useState<boolean>(false);
  const [nextTab, setNextTab] = useState<string>("");
  const dispatch = useDispatch();
  const [currentQueryParameters, setSearchParams] = useSearchParams();
  const newQueryParameters: URLSearchParams = new URLSearchParams();
  const { packages, cocktail, toggleCocktailApi, packageToggle } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  const navigate = useNavigate();
  const [currTab, setCurTab] = useState("");
  const [bartenderList, setBartenderList] = useState<Array<any>>([]);
  const [packagesData, setPackagesData] = useState<Array<any>>([]);
  const [cocktailList, setCocktailList] = useState<Array<any>>([]);
  const [companyData, setCompanyData] = useState<CompanyInterface | null>(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isForm, setIsForm] = useState<TabState>({
    state: "Close",
    id: "",
    tab: tabs.Business,
  });
  // Company data
  useEffect(() => {
    const getData = async () => {
      try {
        const result = await GET(`${getCompanyApi}/${params.id}`, refreshToken);
        //update state for modal
        setCompanyData(result?.data);
      } catch (err) {
        console.log(String(err));
      }
    };
    getData();
  }, []);
  // Get current tab data
  useEffect(() => {
    if (isForm.tab === "barts") {
      (async () => {
        try {
          const result = await GET(
            `${allBartenders}?business_id=${params.id}`,
            refreshToken
          );
          setBartenderList(result?.data);
          // setLoading(false)
        } catch (err) {
          // setError(String(err));
        } finally {
          // setLoading(false);
        }
      })();
    }
    if (isForm.tab === "packages") {
      (async () => {
        try {
          const result = await GET(`${packages}/${params.id}`, refreshToken);
          setPackagesData(result.data);
        } catch (err) {
          console.log(err);
        }
      })();
    }
    if (isForm.tab === "cocktails") {
      (async () => {
        // list of all coctails avaialble
        try {
          const result = await GET(`${cocktail}/${params.id}`, refreshToken);
          setCocktailList(result.data);
        } catch (err) {
          console.log(err);
          // setCustomError('discount', JSON.stringify( err));
        }
      })();
    }
  }, [isForm.tab, isForm.state]);
  // set tab on initial render
  useEffect(() => {
    setCurTab(currentQueryParameters.get("tab") || "business");
    setIsForm({ ...isForm, tab: currentQueryParameters.get("tab") as TabType });
  }, []);
  const handleModalOkay = () => {
    setModal(false);
  };
  const editStateFun = (id: string, name: string) => {
    setIsForm({ ...isForm, state: "Edit", id, name });
  };
  const refreshBartenderList = async () => {
    setIsForm({ ...isForm, state: "Close" });
    (async () => {
      try {
        const result = await GET(
          `${allBartenders}?business_id=${params.id}`,
          refreshToken
        );
        setBartenderList(result?.data);
        console.log("new bartender list get");
        // setLoading(false)
      } catch (err) {
        // setError(String(err));
      } finally {
        // setLoading(false);
      }
    })();
  };
  // toggle cocktail status
  const togglePackage = async (packageId: string, status: boolean) => {
    setCocktailList(
      packagesData.map((item: any) => {
        if (item.id === packageId) {
          item.is_active = status;
        }
        return item;
      })
    );
    const result = await POST(
      `${packageToggle}/${packageId}`,
      {
        status,
      },
      refreshToken
    );
  };
  // toggle cocktail status
  const toggleCocktail = async (cocktailId: string, status: string) => {
    setCocktailList(
      cocktailList.map((item: any) => {
        if (item.id === cocktailId) {
          item.status = status;
        }
        return item;
      })
    );
    const result = await POST(
      `${toggleCocktailApi}/${cocktailId}`,
      {
        status,
      },
      refreshToken
    );
  };
  // search
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };
  const filteredPackage = Array.isArray(packagesData)
    ? packagesData.filter((item) => {
      // in order to search by company and admin name using search query
      const name = item.name.toLowerCase();
      const itemName = item.name.toLowerCase();
      const search = searchQuery.toLowerCase();
      return name.includes(search) || itemName.includes(search);
    })
    : [];
  const filteredCocktail = Array.isArray(cocktailList)
    ? cocktailList.filter((item) => {
      // in order to search by company and admin name using search query
      const name = item.name.toLowerCase();
      const itemName = item.name.toLowerCase();
      const search = searchQuery.toLowerCase();
      return name.includes(search) || itemName.includes(search);
    })
    : [];
  const goBack = () => {
    navigate("/company");
  };
  // update tab also close open forms state (Package and cocktails)
  const updateTab = (name: TabType) => {
    setIsForm({ state: "Close", id: "", tab: name });
    if (isChanged) {
      setModal(true);
      setNextTab(name);
    } else {
      setCurTab(name);
      newQueryParameters.set("tab", "dw");
      navigate(`?tab=${name}`);
    }
  };
  // on add new package close form
  const closeAddPackageForm = () => {
    setIsForm({ ...isForm, state: "Close" });
  };
  // on add new Cocktail close form
  const closeCocktailForm = () => {
    setIsForm({ ...isForm, state: "Close" });
  };
  const handleModalCancel = () => {
    dispatch(formStateChange(false));
    setModal(false);
    setCurTab(nextTab);
    newQueryParameters.set("tab", "dw");
    navigate(`?tab=${nextTab}`);
  };
  return (
    <div>
      {/* <DashboardHeader title="Edit Businesses">
        <div className=" "></div>
      </DashboardHeader> */}
      <div className="flex items-center gap-1 flex-wrap">
        <div className="bg-white p-2 rounded-full cursor-pointer">
          <IoMdArrowBack className=" " onClick={() => goBack()} />
        </div>
        <DashboardHeader title="Edit Businesses"></DashboardHeader>
        <div
          className="flex  items-center mt-2"
          onClick={() => updateTab(tabs.Business)}
        >
          <MdOutlineKeyboardDoubleArrowRight className="text-primary-red" />
          <p className="underline hover:cursor-pointer text-primary-red ">
            {companyData?.name}
          </p>
        </div>
        {currTab === tabs.Bartenders && (
          <>
            <MdOutlineKeyboardDoubleArrowRight className="text-primary-red mt-2" />
            <p
              onClick={() => updateTab(tabs.Bartenders)}
              className="underline hover:cursor-pointer text-primary-red  mt-2 "
            >
              Bartenders
            </p>
            {isForm.state === "Edit" && (
              <>
                <MdOutlineKeyboardDoubleArrowRight className="text-primary-red  mt-2" />
                <p className="underline hover:cursor-pointer text-primary-red  mt-2">
                  {isForm.name}
                </p>
              </>
            )}
          </>
        )}
        {currTab === tabs.Schedules && (
          <>
            <MdOutlineKeyboardDoubleArrowRight className="text-primary-red  mt-2" />
            <p className="underline hover:cursor-pointer text-primary-red mt-2 ">
              Schedules
            </p>
          </>
        )}
        {currTab === tabs.Packages && (
          <>
            <MdOutlineKeyboardDoubleArrowRight className="text-primary-red  mt-2" />
            <p
              onClick={() => {
                updateTab(tabs.Packages);
                // setOpenAddPckgForm(false);
                // setOpenAddCocktailForm(false);
              }}
              className="underline hover:cursor-pointer text-primary-red mt-2 "
            >
              Packages
            </p>
            {isForm.state === "Edit" && (
              <>
                <MdOutlineKeyboardDoubleArrowRight className="text-primary-red  mt-2" />
                <p className="underline hover:cursor-pointer text-primary-red  mt-2">
                  {isForm.name}
                </p>
              </>
            )}
          </>
        )}
        {currTab === tabs.PriceCalculator && (
          <>
            <MdOutlineKeyboardDoubleArrowRight className="text-primary-red  mt-2" />
            <p
              onClick={() => {
                updateTab(tabs.PriceCalculator);
                // setOpenAddPckgForm(false);
                // setOpenAddCocktailForm(false);
              }}
              className="underline hover:cursor-pointer text-primary-red mt-2 "
            >
              Price Calculator
            </p>
            {isForm.state === "Edit" && (
              <>
                <MdOutlineKeyboardDoubleArrowRight className="text-primary-red  mt-2" />
                <p className="underline hover:cursor-pointer text-primary-red  mt-2">
                  {isForm.name}
                </p>
              </>
            )}
          </>
        )}
        {currTab === tabs.Discount && (
          <>
            <MdOutlineKeyboardDoubleArrowRight className="text-primary-red  mt-2" />
            <p
              onClick={() => {
                updateTab(tabs.Discount);
                // setOpenAddPckgForm(false);
                // setOpenAddCocktailForm(false);
              }}
              className="underline hover:cursor-pointer text-primary-red  mt-2"
            >
              Discounts
            </p>
            {/* {showEditPackage.state && (
              <>
                <MdOutlineKeyboardDoubleArrowRight className="text-primary-red" />
                <p className="underline hover:cursor-pointer text-primary-red ">
                  {showEditPackage.name}
                </p>
              </>
            )} */}
          </>
        )}
        {currTab === tabs.Cocktails && (
          <>
            <MdOutlineKeyboardDoubleArrowRight className="text-primary-red  mt-2" />
            <p
              onClick={() => {
                updateTab(tabs.Cocktails);
                // setShowEditCocktail({ state: false, id: "", name: "" });
              }}
              className="underline hover:cursor-pointer text-primary-red  mt-2 "
            >
              Cocktails
            </p>
            {isForm.state === "Edit" && (
              <>
                <MdOutlineKeyboardDoubleArrowRight className="text-primary-red  mt-2" />
                <p className="underline hover:cursor-pointer text-primary-red  mt-2">
                  {isForm.name}
                </p>
              </>
            )}
          </>
        )}
      </div>
      {/* Tabs  */}
      <ul className="flex flex-wrap  font-medium text-center text-gray-500 border-b-2 border-gray-400 ">
        <li className="me-2 cursor-pointer">
          <div
            onClick={() => updateTab(tabs.Business)}
            aria-current="page"
            className={`inline-block p-2 sm:p-4  rounded-t-lg       ${currTab === tabs.Business
              ? "text-primary-red  border-b-2 -mb-2 border-primary-red"
              : "hover:text-primary-red"
              }`}
          >
            Business
          </div>
        </li>
        <li className="me-2 cursor-pointer">
          <div
            onClick={() => updateTab(tabs.Bartenders)}
            className={`inline-block p-2 sm:p-4 rounded-t-lg  ${currTab === tabs.Bartenders
              ? "text-primary-red  border-b-2 -mb-2 border-primary-red"
              : "hover:text-primary-red"
              } `}
          >
            Bartenders
          </div>
        </li>
        <li className="me-2 cursor-pointer">
          <div
            onClick={() => updateTab(tabs.Schedules)}
            className={`inline-block p-2 sm:p-4 rounded-t-lg  ${currTab === tabs.Schedules
              ? "text-primary-red  border-b-2 -mb-2 border-primary-red"
              : "hover:text-primary-red"
              } `}
          >
            Schedules
          </div>
        </li>
        {/* <li className="me-2 cursor-pointer">
          <div
            onClick={() => updateTab(tabs.Packages)}
            className={`inline-block p-2 sm:p-4 rounded-t-lg     ${currTab === tabs.Packages
              ? "text-primary-red  border-b-2 -mb-2 border-primary-red"
              : "hover:text-primary-red"
              } `}
          >
            Packages
          </div>
        </li> */}
        <li className="me-2 cursor-pointer">
          <div
            onClick={() => updateTab(tabs.PriceCalculator)}
            className={`inline-block p-2 sm:p-4 rounded-t-lg     ${currTab === tabs.PriceCalculator
              ? "text-primary-red  border-b-2 -mb-2 border-primary-red"
              : "hover:text-primary-red"
              } `}
          >
            Price Calculator
          </div>
        </li>
        <li className="me-2 cursor-pointer">
          <div
            onClick={() => updateTab(tabs.Discount)}
            className={`inline-block p-2 sm:p-4 rounded-t-lg     ${currTab === tabs.Discount
              ? "text-primary-red  border-b-2 -mb-2 border-primary-red"
              : "hover:text-primary-red"
              } `}
          >
            Discounts
          </div>
        </li>
        <li className="me-2 cursor-pointer mb-2 sm:mb-0">
          <div
            onClick={() => updateTab(tabs.Cocktails)}
            className={`inline-block p-2 sm:p-4 rounded-t-lg   ${currTab === tabs.Cocktails
              ? "text-primary-red  border-b-2 -mb-2 border-primary-red"
              : "hover:text-primary-red"
              } `}
          >
            Cocktails
          </div>
        </li>
      </ul>
      {currTab === tabs.Business && (
        <EditCompany
          addBusinessId={() => console.log("")}
          businessId={params.id}
        />
      )}
      {currTab === tabs.Bartenders && (
        <div>
          <div className="flex justify-between items-center mt-1">
            <div></div>
            {isForm.state === "Close" && (
              <button
                className="bg-black text-white  rounded-full py-2 px-6"
                onClick={() => {
                  setIsForm({ state: "Add", id: "", tab: tabs.Business });
                }}
              >
                <span className="text-lg mr-1">+</span>
                Add New
              </button>
            )}
          </div>
          {/* {isForm.state === "Edit" && (
            <EditBartender isEdit={true} businessId={params.id} />
          )} */}
          {(isForm.state === "Add" || isForm.state === "Edit") && params.id && (
            <AddBTCBySuperAdmin
              btcId={isForm?.id && isForm.id}
              businessId={params.id}
              isEdit={isForm.state === "Edit" ? true : false}
              refreshBartenderList={refreshBartenderList}
            />
          )}

          {isForm.state === "Close" && (
            <div className="mt-4">
              <BartList
                bartendersList={bartenderList}
                editStateFun={editStateFun}
                editBusinessId={params.id as string}
              />
              {/* <BTCTable bartenderss={bartenderList}/> */}
            </div>
          )}
        </div>
      )}
      {currTab === tabs.Schedules && (
        <BartenderSchedulePage businessId={params.id} isSuperAdmin={true} />
      )}
      {currTab === tabs.Packages && (
        <>
          {isForm.state === "Close" && (
            <div className="flex justify-between items-center gap-2 mt-2 flex-wrap">
              <input
                type="search"
                value={searchQuery}
                onChange={handleSearch}
                placeholder="Search by Name"
                className="  min-w-48 md:min-w-64 px-4 py-3  rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600 "
              />
              <button
                className="bg-black text-white  rounded-full py-2 px-6"
                onClick={() => {
                  setIsForm({ state: "Add", id: "", tab: tabs.Packages });
                }}
              >
                <span className="text-lg mr-1">+</span>
                Add New
              </button>
            </div>
          )}
          {isForm.state === "Close" && (
            <div className="relative overflow-x-auto  rounded-2xl mt-4 overflow-y-auto max-h-full">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-white">
                  <tr>
                    <th
                      scope="col"
                      className="px-2 sm:px-4 py-3"
                    >
                      Sr#.
                    </th>
                    <th
                      scope="col"
                      className="px-2 sm:px-4 py-3"
                    >
                      Guest Per Bartender
                    </th>
                    <th
                      scope="col"
                      className="px-2 sm:px-4 py-3"
                    >
                      Package Name
                    </th>
                    <th
                      scope="col"
                      className="px-2 sm:px-4 py-3"
                    >
                      Type
                    </th>
                    <th
                      scope="col"
                      className="px-2 sm:px-4 py-3"
                    >
                      Supplies
                    </th>
                    <th
                      scope="col"
                      className="px-2 sm:px-4 py-3"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPackage.map((item, index) => {
                    return (
                      <tr key={index} className="odd:bg-white even:bg-gray-50">
                        <th
                          scope="row"
                          className="px-2 sm:px-4 py-4 font-medium text-gray-900 whitespace-nowrap "
                        >
                          {index + 1}
                        </th>
                        <td className="px-2 sm:px-4 py-4">
                          {/* <img className="h-14 w-14 object-cover rounded-full " src={item.image} /> */}
                          {item?.guests_per_bartender}
                        </td>
                        <td className="px-2 sm:px-4 py-4 min-w-32 ">
                          {item?.name}
                        </td>
                        <td className="px-2 sm:px-4 py-4 capitalize">{item?.type}</td>
                        <td className="px-2 sm:px-4 py-4 min-w-48">
                          {item?.supplies.map((data: string) => {
                            return data + ", ";
                          })}
                        </td>
                        <td className="px-2 sm:px-4 py-4">
                          <div className="cursor-pointer flex gap-3 items-center">
                            <ToggleInput
                              // disabled={getCompletion(item) != 100}
                              onChange={() =>
                                togglePackage(
                                  item.id,
                                  item?.is_active ? false : true
                                )
                              }
                              checked={item.is_active}
                            />
                            <div
                              onClick={() => {
                                setIsForm({
                                  state: "Edit",
                                  id: item.id,
                                  tab: tabs.Packages,
                                  name: item.name,
                                });
                              }}
                            >
                              <div
                                className="cursor-pointer flex gap-3 bg-p-gray rounded-full p-2 "
                              >
                                <FiEdit2 size={14} />
                              </div>
                            </div>

                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {isForm.state === "Edit" && <EditPackage packageId={isForm.id} />}
          {isForm.state === "Add" && companyData && (
            <CreatePackage
              closeAddPackageForm={closeAddPackageForm}
              businessId={companyData?.id}
              isNew={true}
            />
          )}
        </>
      )}
      {currTab === tabs.PriceCalculator && (
        <>
          <PriceCalculator params={{ currentBusiness: params.id }} />
        </>
      )}
      {currTab === tabs.Discount && (
        <div>
          <DiscountManager isAdmin={true} businessId={params.id} />
        </div>
      )}
      {currTab === tabs.Cocktails && (
        <>
          {isForm.state === "Close" && (
            <div className="flex  flex-wrap justify-between items-center gap-2 mt-2">
              <input
                value={searchQuery}
                onChange={handleSearch}
                placeholder="Search by Name"
                className="  min-w-48 md:min-w-64 px-4 py-3  rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600 "
              />
              <button
                className="bg-black text-white  rounded-full py-2 px-6"
                onClick={() => {
                  // setOpenAddCocktailForm(true);
                  setIsForm({
                    state: "Add",
                    id: "",
                    tab: tabs.Cocktails,
                  });
                }}
              >
                <span className="text-lg mr-1">+</span>
                Add New
              </button>
            </div>
          )}
          {isForm.state === "Close" && (
            <div className="relative overflow-x-auto  sm:rounded-lg mt-4 overflow-y-auto ">
              <div className="grid lg:grid-cols-3 gap-4 md:grid-cols-2 grid=col-1 ">

                {filteredCocktail.length > 0 &&
                  filteredCocktail.map((cock: Cocktail) => {
                    return (
                      <div key={cock.id}>
                        <div className="bg-white px-4 pt-4 pb-1 rounded-xl flex items-center gap-2 max-w-[380px]">
                          <div className="w-4/12">
                            <img
                              src={cock.image}
                              alt={cock.name}
                              className="w-20 h-20  rounded-full"
                            />
                          </div>
                          <div className="w-8/12">
                            <p>{cock.name}</p>
                            <p className="text-sm text-gray-500">Type: {cock.type}</p>
                            <div className="flex justify-end items-center min-w-40 gap-2">
                              <div onClick={() =>
                                setIsForm({
                                  state: "Edit",
                                  tab: "cocktails",
                                  id: cock.id,
                                  name: cock.name,
                                })
                              } className="cursor-pointer flex gap-2 bg-p-gray rounded-full px-4 py-1 items-center text-xs">
                                <FiEdit2 size={12} />
                                Edit
                              </div>
                              <ToggleInput
                                onChange={() =>
                                  toggleCocktail(
                                    cock.id,
                                    cock?.status == "active"
                                      ? "unavailable"
                                      : "active"
                                  )
                                }
                                checked={cock.status == "active"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}

          {isForm.state === "Edit" && <EditCocktail cocktailId={isForm.id} />}
          {companyData && isForm.state === "Add" && (
            <CreateCocktails
              closeCocktailForm={closeCocktailForm}
              businessId={companyData.id}
            />
          )}
        </>
      )}
      {modal && (
        <ChangesAlert
          isOpen={modal}
          title="Unsaved Changed"
          desc="You have unsaved changes. Are you sure you want to leave?"
          positiveButtonText="No, Stay"
          negativeButtonText="Yes, Leave"
          handleDiscardChanges={handleModalCancel}
          handleSaveChanges={handleModalOkay}
        />
      )}
    </div>
  );
};

export default EditCompanyPage;
